// import React, { useState, useEffect } from "react";
// import { Header } from "../../Header";
// import CircularProgress from "@mui/material/CircularProgress";
// import TextField from "@mui/material/TextField";
// import FormControl from "@mui/material/FormControl";
// import InputLabel from "@mui/material/InputLabel";
// import MenuItem from "@mui/material/MenuItem";
// import Select from "@mui/material/Select";
// import Grid from "@mui/material/Grid";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import dayjs from "dayjs";
// import "./Customer.css";
// import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
// import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
// import { local_url } from "../../Const";
// import { Button } from '@mui/material';
// import Autocomplete from "@mui/material/Autocomplete";
// import Pagination from '@mui/material/Pagination';




// const formatDate = (date, formatType) => {
//   if (!date) return "-";
//   const d = new Date(date);

//   if (formatType === "date") {
//     return `${String(d.getDate()).padStart(2, "0")}-${String(
//       d.getMonth() + 1
//     ).padStart(2, "0")}-${d.getFullYear()}`;
//   }


//   return "-";
// };

// export const BranchDayRateReport = () => {
//   const [reportData, setReportData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [branchId, setBranchId] = useState("");
//   const [toDate, setToDate] = useState(dayjs());
//   const [fromDate, setFromDate] = useState(dayjs());

//   const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
//   const [branchList, setBranchList] = useState([]);

//   const [page, setPage] = useState(1);
//   const [rowsPerPage] = useState(200);
//   const [paginatedData, setPaginatedData] = useState([]);

//   // Dropdown state management
//   const [area, setArea] = React.useState("");
//   const [type, setType] = React.useState("");
//   const [branch, setBranch] = React.useState("");
//   const [branchType, setBranchType] = React.useState("");
//   const [items, setItems] = React.useState("");
//   const [areas, setAreas] = useState([]);




//   useEffect(() => {
//     const startIndex = (page - 1) * rowsPerPage;
//     const endIndex = startIndex + rowsPerPage;
//     setPaginatedData(filteredData.slice(startIndex, endIndex));
//   }, [filteredData, page, rowsPerPage]);

//   const totalPages = Math.ceil(filteredData.length / rowsPerPage);

//   // Handle page change
//   const handlePageChange = (event, newPage) => {
//     setPage(newPage);
//   };

//   // Add an effect to log state changes
//   useEffect(() => {
//     console.log('State updated:', {
//       type,
//       branchType,
//       branch,
//       branchList,
//       branchId
//     });
//   }, [type, branchType, branch, branchList, branchId]);






//   const fetchBranchList = async (fetchType, value) => {
//     const token = localStorage.getItem('AuthorizationToken');

//     if (!token) {
//       console.error('Authentication token is missing');
//       alert("Authentication token is missing. Please log in again.");
//       localStorage.clear();
//       sessionStorage.clear();
//       window.location.href = "/login";
//       return;
//     }

//     try {
//       let url;
//       if (fetchType === 'AREA') {
//         url = `${local_url}/api/Company/GetBranchList/${value}/AREA/${value}`;
//       } else if (fetchType === 'RTYPE') {
//         url = `${local_url}/api/Company/GetBranchList/ALL/RTYPE/${value}`;
//       }

//       console.log('Fetching from URL:', url); // Debug log

//       const response = await fetch(url, {
//         method: 'GET',
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//       });

//       if (!response.ok) {
//         if (response.status === 401) {
//           alert("Unauthorized. Session expired. Please log in again.");
//           localStorage.clear();
//           sessionStorage.clear();
//           window.location.href = "/login";
//           return;
//         }
//         throw new Error('Failed to fetch branch list');
//       }

//       const data = await response.json();
//       console.log('Fetched branch list:', data); // Debug log
//       setBranchList(data);
//     } catch (error) {
//       console.error('Error fetching branch list:', error);
//       setBranchList([]);
//     }
//   };


//   const handleAreaChange = (event, newValue) => {
//     const selectedArea = newValue?.sfAreaId || "ALL";
//     setArea(selectedArea);

//     if (type === 'branch') {
//       fetchBranchList('AREA', selectedArea);
//     }

//     setBranch("ALL");
//     setBranchId("ALL");
//     setBranchList([]);
//   };

//   const handleTypeChange = (event, newValue) => {
//     const selectedType = newValue?.value || "";
//     setType(selectedType);
//     setBranchType("");
//     setBranch("ALL");
//     setBranchId("ALL");
//     setBranchList([]);

//     if (selectedType === 'branch' && area) {
//       fetchBranchList('AREA', area);
//     }
//   };


//   const handleBranchTypeChange = (event, newValue) => {
//     const selectedBranchType = newValue?.value || "ALL";
//     setBranchType(selectedBranchType);
//     setBranch('ALL');
//     setBranchId('ALL');

//     if (selectedBranchType !== "ALL") {
//       fetchBranchList('RTYPE', selectedBranchType);
//     }
//   };

//   const handleBranchChange = (event, newValue) => {
//     const selectedBranchId = newValue?.branchID || "ALL";
//     setBranch(selectedBranchId);
//     setBranchId(selectedBranchId);
//   };

//   const handleItemsChange = (event, newValue) => {
//     setItems(newValue?.value || "");
//   };




//   const userId = localStorage.getItem('userId');
//   console.log("Retrieved userId:", userId);
//   const handleFromDateChange = (newValue) => {
//     setFromDate(newValue);
//     // Reset toDate if it's before fromDate
//     if (toDate && dayjs(toDate).isBefore(newValue)) {
//       setToDate(newValue);
//     }
//   };





//   useEffect(() => {
//     const fetchAreas = async () => {
//       try {
//         const response = await fetch(`${local_url}/api/SFArea/${userId}`);
//         const data = await response.json();
//         setAreas(data);
//       } catch (error) {
//         console.error('Error fetching areas:', error);
//       }
//     };
//     console.log("------", userId);
//     fetchAreas();
//   }, []);





//   const handleToDateChange = (newValue) => {
//     setToDate(newValue);
//   };







//   const fetchReportData = async () => {
//     if (!fromDate || !toDate) {
//       setError("Please select both From Date and To Date");
//       return;
//     }

//     const formattedFromDate = fromDate.format('YYYYMMDD');
//     const formattedToDate = toDate.format('YYYYMMDD');

//     setLoading(true);
//     setError(null);

//     const token = localStorage.getItem('AuthorizationToken');

//     if (!token) {
//       handleAuthError();
//       return;
//     }

//     // Default values if nothing is selected
//     const selectedArea = area || "ALL";
//     const selectedBranchId = branchId || "ALL";
//     const selectedBranch = branch || "ALL";
//     const selectedBranchType = branchType || "ALL";

//     // Construct API URL based on selected filters
//     let apiUrl = `${local_url}/api/BranchRateReport/Get`;

//     if (type === 'branch') {
//       apiUrl = `${apiUrl}/${selectedArea}/${selectedBranchId}/${formattedFromDate}/${formattedToDate}`;
//     } else if (type === 'branch-type') {
//       apiUrl = `${apiUrl}/${selectedArea}/${selectedBranchType}/${selectedBranch}/${formattedFromDate}/${formattedToDate}`;
//     }

//     try {
//       const response = await fetch(apiUrl, {
//         method: 'GET',
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//       });

//       if (!response.ok) {
//         if (response.status === 401) {
//           handleAuthError();
//           return;
//         }
//         throw new Error("Network response was not ok");
//       }

//       const data = await response.json();

//       if (!data || data.length === 0) {
//         setError("No data found for the selected criteria");
//         setReportData([]);
//         setFilteredData([]);
//       } else {
//         setReportData(data);
//         setFilteredData(data);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       setError(`Failed to fetch report data. ${error.message}`);
//       setReportData([]);
//       setFilteredData([]);
//     } finally {
//       setLoading(false);
//     }
//   };



//   const renderSearchableDropdown = (
//     id,
//     label,
//     options,
//     value,
//     onChange,
//     getOptionLabel,
//     disabled = false
//   ) => {
//     // Add "ALL" option to branch type options if not present
//     const updatedOptions = id === "branch-type-select"
//       ? [{ value: "ALL", label: "ALL" }, ...options]
//       : options;

//     return (
//       <Autocomplete
//         id={id}
//         options={updatedOptions}
//         value={value}
//         onChange={onChange}
//         getOptionLabel={getOptionLabel}
//         renderInput={(params) => (
//           <TextField
//             {...params}
//             label={label}
//             variant="outlined"
//             style={{ minWidth: 150 }}
//           />
//         )}
//         disabled={disabled}
//         isOptionEqualToValue={(option, value) => {
//           if (id === "branch-type-select") {
//             return option.value === (value?.value || "ALL");
//           }
//           return option?.value === value?.value ||
//             option?.sfAreaId === value?.sfAreaId ||
//             option?.branchID === value?.branchID;
//         }}
//         style={{ minWidth: 150 }}
//       />
//     );
//   };




//   const handleAuthError = () => {
//     setError("Authentication token is missing.");
//     setLoading(false);
//     alert("Authentication token is missing. Please log in again.");
//     localStorage.clear();
//     sessionStorage.clear();
//     window.location.href = "/login";
//   };


//   const renderSortIcon = (columnKey) => {
//     if (sortConfig.key === columnKey) {
//       return sortConfig.direction === "asc" ? (
//         <ArrowDropUpIcon fontSize="small" />
//       ) : (
//         <ArrowDropDownIcon fontSize="small" />
//       );
//     }
//     return <ArrowDropUpIcon fontSize="small" style={{ color: 'black' }} />;
//   };

//   const handleSort = (columnKey) => {
//     let direction = "asc";
//     if (sortConfig.key === columnKey && sortConfig.direction === "asc") {
//       direction = "desc";
//     }

//     const sortedData = [...filteredData].sort((a, b) => {
//       // Special handling for S.No. column
//       if (columnKey === "sno") {
//         const indexA = reportData.indexOf(a);
//         const indexB = reportData.indexOf(b);
//         return direction === "asc" ? indexA - indexB : indexB - indexA;
//       }

//       // Handle numeric values
//       if (typeof a[columnKey] === 'number' && typeof b[columnKey] === 'number') {
//         return direction === "asc" ? a[columnKey] - b[columnKey] : b[columnKey] - a[columnKey];
//       }

//       // Handle null/undefined values
//       if (a[columnKey] === null || a[columnKey] === undefined) return 1;
//       if (b[columnKey] === null || b[columnKey] === undefined) return -1;

//       // Handle string values
//       const valueA = String(a[columnKey]).toLowerCase();
//       const valueB = String(b[columnKey]).toLowerCase();

//       return direction === "asc"
//         ? valueA.localeCompare(valueB)
//         : valueB.localeCompare(valueA);
//     });

//     setFilteredData(sortedData);
//     setSortConfig({ key: columnKey, direction });
//   };

//   const handleSearch = (event) => {
//     const query = event.target.value.toLowerCase();
//     setSearchQuery(query);

//     const filtered = reportData.filter((item) =>
//       (item.itemName?.toLowerCase() || "").includes(query) ||
//       (item.itemCode?.toLowerCase() || "").includes(query)
//     );

//     setFilteredData(filtered);
//   };

//   const exportToCSV = () => {
//     const csvRows = [];

//     const headers = [
//       "S.No.", "Rate Type", "From Date", "Location Code", "Item Code", "Item Name",
//       "Item Family ID", "Retail Base", "Retail Markup %", "Retail Price",
//       "Party Base", "Party Markup %", "Party Price",
//       "Hotel Base", "Hotel Markup %", "Hotel Price",
//       "Wholesale Base", "Wholesale Markup %", "Wholesale Price"
//     ];
//     csvRows.push(headers.join(","));

//     reportData.forEach((item, index) => {
//       const row = [
//         index + 1,
//         item.rateType || "-",
//         formatDate(item.fromDate, "date"),
//         item.locCode || "-",
//         item.itemCode || "-",
//         item.itemName || "-",
//         item.itemFamilyID || "-",
//         item.retailBase?.toFixed(2) || "0.00",
//         item.retailMarkup_pc?.toFixed(2) || "0.00",
//         item.retailPrice?.toFixed(2) || "0.00",
//         item.partyBase?.toFixed(2) || "0.00",
//         item.partyMarkup_pc?.toFixed(2) || "0.00",
//         item.partyPrice?.toFixed(2) || "0.00",
//         item.hotelBase?.toFixed(2) || "0.00",
//         item.hotelMarkup_pc?.toFixed(2) || "0.00",
//         item.hotelPrice?.toFixed(2) || "0.00",
//         item.wholeSaleBase?.toFixed(2) || "0.00",
//         item.wholeSaleMarkup_pc?.toFixed(2) || "0.00",
//         item.wholeSalePrice?.toFixed(2) || "0.00"
//       ];

//       csvRows.push(row.join(","));
//     });

//     const csvContent = "data:text/csv;charset=utf-8," + csvRows.join("\n");
//     const encodedUri = encodeURI(csvContent);
//     const link = document.createElement("a");
//     link.setAttribute("href", encodedUri);
//     link.setAttribute("download", `branch_rate_report_${branchId}.csv`);
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   return (
//     <>
//       <Header />
//       <div className="customer-container">
//         <div className="filter-container" style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px', flexWrap: 'wrap', minWidth: '180px' }}>

//           {/* Area Dropdown */}
//           {renderSearchableDropdown(
//             "area-select",
//             "Area",
//             [{ sfAreaId: "branch", sfAreaName: "All" }, ...areas],
//             areas.find(a => a.sfAreaId === area) || null,
//             handleAreaChange,
//             (option) => option.sfAreaName
//           )}

//           {/* Type Dropdown */}
//           {renderSearchableDropdown(
//             "type-select",
//             "Type",
//             [
//               { value: "branch", label: "Branch" },
//               { value: "branch-type", label: "Branch Type" }
//             ],
//             { value: type, label: type === "branch" ? "Branch" : "Branch Type" },
//             handleTypeChange,
//             (option) => option.label
//           )}

//           {/* Branch Type Dropdown */}
//           {type === 'branch-type' && renderSearchableDropdown(
//             "branch-type-select",
//             "Branch Type",
//             [
//               { value: "LAZIZ", label: "LAZIZ" },
//               { value: "RETAIL", label: "RETAIL" }
//             ],
//             branchType ? { value: branchType, label: branchType } : { value: "ALL", label: "ALL" },
//             handleBranchTypeChange,
//             (option) => option.label
//           )}

//           {/* Branch Dropdown */}
//           {(type === 'branch' || (type === 'branch-type' && branchType)) && renderSearchableDropdown(
//             "branch-select",
//             "Branch",
//             [{ branchID: "ALL", branchName: "ALL" }, ...branchList],
//             branchList.find(b => b.branchID === branch) || { branchID: "ALL", branchName: "ALL" },
//             handleBranchChange,
//             (option) => option.branchName
//           )}

//           {/* Items Dropdown */}
//           {renderSearchableDropdown(
//             "items-select",
//             "Items",
//             [
//               { value: "ALL", label: "All" },
//               { value: "none", label: "None" }
//             ],
//             { value: items, label: items === "all" ? "All" : "None" },
//             handleItemsChange,
//             (option) => option.label
//           )}

//           {/* Keep existing DatePickers and Submit button */}
//           <LocalizationProvider dateAdapter={AdapterDayjs}>
//             <DatePicker
//               label="From Date"
//               value={fromDate}
//               onChange={handleFromDateChange}
//               format="DD/MM/YYYY"
//               slotProps={{
//                 textField: {
//                   size: 'small',
//                   sx: { width: 150, backgroundColor: '#F1F8E9' },
//                 },
//               }}
//             />
//           </LocalizationProvider>

//           <LocalizationProvider dateAdapter={AdapterDayjs}>
//             <DatePicker
//               label="To Date"
//               value={toDate}
//               onChange={handleToDateChange}
//               minDate={fromDate}
//               maxDate={dayjs(fromDate).add(40, 'day')}
//               format="DD/MM/YYYY"
//               slotProps={{
//                 textField: {
//                   size: 'small',
//                   sx: { width: 150, backgroundColor: '#F1F8E9' },
//                 },
//               }}
//             />
//           </LocalizationProvider>

//           <Button
//             onClick={fetchReportData}
//             variant="contained"
//             style={{ height: '40px' }}
//             disabled={loading}
//           >
//             Submit
//           </Button>

//           <Button
//             onClick={exportToCSV}
//             variant="contained"
//             style={{ height: '40px', backgroundColor: '#4CAF50' }}
//             disabled={loading || reportData.length === 0}
//           >
//             Export
//           </Button>
//         </div>



//         <div className="customer-table-container">
//           <div className="customer-table-scroll">
//             <table className="customer-table">
//               <thead>
//                 <tr>
//                   <th onClick={() => handleSort("sno")}>
//                     S.No. {renderSortIcon("sno")}
//                   </th>
//                   <th onClick={() => handleSort("rateType")}>
//                     Rate Type {renderSortIcon("rateType")}
//                   </th>
//                   <th onClick={() => handleSort("fromDate")}>
//                     From Date {renderSortIcon("fromDate")}
//                   </th>
//                   <th onClick={() => handleSort("locCode")}>
//                     Location Code {renderSortIcon("locCode")}
//                   </th>
//                   <th onClick={() => handleSort("itemCode")}>
//                     Item Code {renderSortIcon("itemCode")}
//                   </th>
//                   <th onClick={() => handleSort("itemName")}>
//                     Item Name {renderSortIcon("itemName")}
//                   </th>
//                   <th onClick={() => handleSort("itemFamilyID")}>
//                     Item Family ID {renderSortIcon("itemFamilyID")}
//                   </th>
//                   <th onClick={() => handleSort("retailBase")}>
//                     Retail Base {renderSortIcon("retailBase")}
//                   </th>
//                   <th onClick={() => handleSort("retailMarkup_pc")}>
//                     Retail Markup % {renderSortIcon("retailMarkup_pc")}
//                   </th>
//                   <th onClick={() => handleSort("retailPrice")}>
//                     Retail Price {renderSortIcon("retailPrice")}
//                   </th>
//                   <th onClick={() => handleSort("partyBase")}>
//                     Party Base {renderSortIcon("partyBase")}
//                   </th>
//                   <th onClick={() => handleSort("partyMarkup_pc")}>
//                     Party Markup % {renderSortIcon("partyMarkup_pc")}
//                   </th>
//                   <th onClick={() => handleSort("partyPrice")}>
//                     Party Price {renderSortIcon("partyPrice")}
//                   </th>
//                   <th onClick={() => handleSort("hotelBase")}>
//                     Hotel Base {renderSortIcon("hotelBase")}
//                   </th>
//                   <th onClick={() => handleSort("hotelMarkup_pc")}>
//                     Hotel Markup % {renderSortIcon("hotelMarkup_pc")}
//                   </th>
//                   <th onClick={() => handleSort("hotelPrice")}>
//                     Hotel Price {renderSortIcon("hotelPrice")}
//                   </th>
//                   <th onClick={() => handleSort("wholeSaleBase")}>
//                     Wholesale Base {renderSortIcon("wholeSaleBase")}
//                   </th>
//                   <th onClick={() => handleSort("wholeSaleMarkup_pc")}>
//                     Wholesale Markup % {renderSortIcon("wholeSaleMarkup_pc")}
//                   </th>
//                   <th onClick={() => handleSort("wholeSalePrice")}>
//                     Wholesale Price {renderSortIcon("wholeSalePrice")}
//                   </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {loading ? (
//                   <tr>
//                     <td colSpan="19" className="customer-loading-container">
//                       <CircularProgress />
//                     </td>
//                   </tr>
//                 ) : paginatedData.length > 0 ? (
//                   paginatedData.map((item, idx) => (
//                     <tr key={idx}>
//                       <td>{((page - 1) * rowsPerPage) + idx + 1}</td>
//                       <td>{item.rateType || "-"}</td>
//                       <td>{formatDate(item.fromDate, "date")}</td>
//                       <td>{item.locCode || "-"}</td>
//                       <td>{item.itemCode || "-"}</td>
//                       <td>{item.itemName || "-"}</td>
//                       <td>{item.itemFamilyID || "-"}</td>
//                       <td>{item.retailBase?.toFixed(2) || "0.00"}</td>
//                       <td>{item.retailMarkup_pc?.toFixed(2) || "0.00"}</td>
//                       <td>{item.retailPrice?.toFixed(2) || "0.00"}</td>
//                       <td>{item.partyBase?.toFixed(2) || "0.00"}</td>
//                       <td>{item.partyMarkup_pc?.toFixed(2) || "0.00"}</td>
//                       <td>{item.partyPrice?.toFixed(2) || "0.00"}</td>
//                       <td>{item.hotelBase?.toFixed(2) || "0.00"}</td>
//                       <td>{item.hotelMarkup_pc?.toFixed(2) || "0.00"}</td>
//                       <td>{item.hotelPrice?.toFixed(2) || "0.00"}</td>
//                       <td>{item.wholeSaleBase?.toFixed(2) || "0.00"}</td>
//                       <td>{item.wholeSaleMarkup_pc?.toFixed(2) || "0.00"}</td>
//                       <td>{item.wholeSalePrice?.toFixed(2) || "0.00"}</td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="19" className="customer-no-data-container">
//                       No data available.
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//           {filteredData.length > 0 && (
//             <div className="pagination-container" style={{
//               padding: '20px',
//               display: 'flex',
//               justifyContent: 'center',
//               alignItems: 'center',
//               gap: '20px'
//             }}>
//               <div style={{ color: '#666' }}>
//                 Showing {(page - 1) * rowsPerPage + 1} to {Math.min(page * rowsPerPage, filteredData.length)} of {filteredData.length} entries
//               </div>
//               <Pagination
//                 count={totalPages}
//                 page={page}
//                 onChange={handlePageChange}
//                 color="primary"
//                 shape="rounded"
//               />
//             </div>
//           )}
//         </div>
//       </div>
//     </>
//   );
// };

// export default BranchDayRateReport;



























































//Date Changes 29/01


import React, { useState, useEffect } from "react";
import { Header } from "../../Header";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "./Customer.css";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { local_signage, local_url } from "../../Const";
import { Button } from '@mui/material';
import Autocomplete from "@mui/material/Autocomplete";
import Pagination from '@mui/material/Pagination';

const formatDate = (date, formatType) => {
  if (!date) return "-";
  const d = new Date(date);

  if (formatType === "date") {
    return `${String(d.getDate()).padStart(2, "0")}-${String(
      d.getMonth() + 1
    ).padStart(2, "0")}-${d.getFullYear()}`;
  }

  return "-";
};

export const BranchDayRateReport = () => {
  const [reportData, setReportData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [branchId, setBranchId] = useState("");
  const [toDate, setToDate] = useState(dayjs());
  const [fromDate, setFromDate] = useState(dayjs());
  const [branchInputValue, setBranchInputValue] = useState("");
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [branchList, setBranchList] = useState([]);

  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(200);
  const [totalPages, setTotalPages] = useState(0);

  // Dropdown state management
  const [area, setArea] = useState("ALL");
  const [branchType, setBranchType] = useState(""); // First dropdown now
  const [branch, setBranch] = useState("");
  const [areas, setAreas] = useState([]);
  const [segments, setSegments] = useState([]);

  const userId = localStorage.getItem('userId');
  const token = localStorage.getItem('AuthorizationToken');

  // Fetch business segments when component mounts
  useEffect(() => {
    const fetchSegments = async () => {
      try {
        const response = await fetch(`${local_url}/api/BizSegments`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          if (response.status === 401) {
            handleAuthError();
            return;
          }
          throw new Error('Failed to fetch business segments');
        }

        const data = await response.json();
        console.log('Fetched business segments:', data);

        // Filter out deleted segments
        const activeSegments = data.filter(segment => segment.deleted === "N");
        setSegments(activeSegments);
      } catch (error) {
        console.error('Error fetching business segments:', error);
      }
    };

    if (token) {
      fetchSegments();
    }
  }, [token]);

  // Fetch areas when branchType (segment) changes
  useEffect(() => {
    const fetchAreas = async () => {
      if (!branchType) return;

      try {
        const response = await fetch(`${local_signage}/api/v1/sfareabysegment?SegmentCode=${branchType}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          if (response.status === 401) {
            handleAuthError();
            return;
          }
          throw new Error('Failed to fetch areas by segment');
        }

        const data = await response.json();
        console.log('Fetched areas for segment:', data);
        setAreas(data);
        // Reset area selection to ALL
        setArea("ALL");
      } catch (error) {
        console.error('Error fetching areas by segment:', error);
        setAreas([]);
      }
    };

    if (token && branchType) {
      fetchAreas();
    }
  }, [branchType, token]);

  // When area changes, fetch branches
  useEffect(() => {
    const fetchBranches = async () => {
      if (branchType && area) {
        await fetchBranchList('RTYPE', branchType);
      }
    };

    fetchBranches();
  }, [area, branchType]);

  // Handle branch type change
  const handleBranchTypeChange = (event) => {
    const selectedBranchType = event.target.value;
    console.log('Selected branch type:', selectedBranchType);
    setBranchType(selectedBranchType);

    // Reset branch selection
    setBranch('');
    setBranchId('');
    setSelectedBranch(null);
    setBranchInputValue("");
  };

  // Handle area change
  const handleAreaChange = (event) => {
    const selectedArea = event.target.value;
    console.log('Selected area:', selectedArea);
    setArea(selectedArea);

    // Reset branch selection
    setBranch('');
    setBranchId('');
    setSelectedBranch(null);
    setBranchInputValue("");

    // Fetch branches again with new area
    if (branchType) {
      fetchBranchList('RTYPE', branchType);
    }
  };

  // Fetch branch list
  const fetchBranchList = async (fetchType, value) => {
    if (!token) {
      console.error('Authentication token is missing');
      handleAuthError();
      return;
    }

    try {
      // Use the selected area ID for API call
      const areaParam = area || "ALL";
      const url = `${local_url}/api/Company/GetBranchList/${areaParam}/SEGMENT/${value}`;

      console.log('Fetching branches from URL:', url);

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        if (response.status === 401) {
          handleAuthError();
          return;
        }
        throw new Error('Failed to fetch branch list');
      }

      const data = await response.json();
      console.log('Fetched branch list:', data);
      setBranchList(data);
    } catch (error) {
      console.error('Error fetching branch list:', error);
      setBranchList([]);
    }
  };

  // Handle branch selection
  const handleBranchChange = (event, newValue) => {
    setSelectedBranch(newValue);
    if (newValue) {
      setBranch(newValue.branchID);
      setBranchId(newValue.branchID);
    } else {
      setBranch("");
      setBranchId("");
    }
  };

  // Get current page data
  useEffect(() => {
    if (reportData.length > 0) {
      const filtered = reportData.filter((item) =>
        (item.itemName?.toLowerCase() || "").includes(searchQuery.toLowerCase()) ||
        (item.itemCode?.toLowerCase() || "").includes(searchQuery.toLowerCase())
      );
      setFilteredData(filtered);
      setTotalPages(Math.ceil(filtered.length / rowsPerPage));
      setPage(1); // Reset to first page when filter changes
    }
  }, [searchQuery, reportData, rowsPerPage]);

  // Handle date changes
  const handleFromDateChange = (newValue) => {
    setFromDate(newValue);
    // Reset toDate if it's before fromDate
    if (toDate && dayjs(toDate).isBefore(newValue)) {
      setToDate(newValue);
    }
  };

  const handleToDateChange = (newValue) => {
    setToDate(newValue);
  };

  // Handle page changes
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  // Get current page data
  const getCurrentPageData = () => {
    const startIndex = (page - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return filteredData.slice(startIndex, endIndex);
  };

// Fetch report data with fixed parameter handling
const fetchReportData = async () => {
  // Validation for dates
  if (!fromDate) {
    setError("Please select Business Date");
    alert("Please select Business Date");
    return;
  }
  
  // Require branchType selection if not already selected
  if (!branchType || branchType === '') {
    setError("Please select a Segment");
    alert("Please select a Segment");
    return;
  }
  
  const formattedFromDate = fromDate.format('YYYYMMDD');
  
  setLoading(true);
  setError(null);
  
  if (!token) {
    handleAuthError();
    return;
  }

  // Get the parameter values without quotes
  // Only add quotes if the parameter is empty
  const areaParam = area === "ALL" ? "''" : area;
  const branchParam = branch ? branch : "''";
  const branchTypeParam = branchType;

  // Construct API URL with the new parameter handling
  const url = new URL(`${local_signage}/api/v1/areawisebranchratereport`);
  
  // Add parameters to URL without quotes (except for empty values)
  url.searchParams.append("AreaId", areaParam);
  url.searchParams.append("BranchId", branchParam);
  url.searchParams.append("RTYPE", branchTypeParam);
  url.searchParams.append("BizDate", formattedFromDate);
  
  const apiUrl = url.toString();
  console.log('API URL for report data:', apiUrl);

  try {
    const response = await fetch(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      if (response.status === 401) {
        handleAuthError();
        return;
      }
      throw new Error("Network response was not ok");
    }

    const data = await response.json();

    if (!data || data.length === 0) {
      setError("No data found for the selected criteria");
      alert("No data found for the selected criteria");
      setReportData([]);
      setFilteredData([]);
    } else {
      // Transform the data to match the expected structure
      const transformedData = data.map(item => ({
        rateType: item.RateType || "-",
        fromDate: item.FromDate,
        locCode: item.Branch || "-",
        itemCode: item.itemCode || "-",
        itemName: item.ItemName || "-",
        itemFamilyID: item.ItemFamilyID || "-",
        retailPrice: item.RetailPrice || 0,
        partyPrice: item.PartyPrice || 0,
        hotelPrice: item.HotelPrice || 0,
        wholeSalePrice: item.WholeSalePrice || 0,
        // Add additional fields from the new API response
        branchName: item.BranchName || "-",
        area: item.Area || "-",
        rType: item.RType || "-",
        baseCode: item.BaseCode || "-",
      }));
      
      setReportData(transformedData);
      setFilteredData(transformedData);
      setTotalPages(Math.ceil(transformedData.length / rowsPerPage));
      setPage(1);
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    setError(`Failed to fetch report data: ${error.message}`);
    alert(`Failed to fetch report data: ${error.message}`);
    setReportData([]);
    setFilteredData([]);
  } finally {
    setLoading(false);
  }
};

  const handleAuthError = () => {
    setError("Authentication token is missing.");
    setLoading(false);
    alert("Authentication token is missing. Please log in again.");
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/login";
  };

  const renderSortIcon = (columnKey) => {
    if (sortConfig.key === columnKey) {
      return sortConfig.direction === "asc" ? (
        <ArrowDropUpIcon fontSize="small" />
      ) : (
        <ArrowDropDownIcon fontSize="small" />
      );
    }
    return <ArrowDropUpIcon fontSize="small" style={{ color: 'black' }} />;
  };

  const handleSort = (columnKey) => {
    let direction = "asc";
    if (sortConfig.key === columnKey && sortConfig.direction === "asc") {
      direction = "desc";
    }

    const sortedData = [...filteredData].sort((a, b) => {
      // Special handling for S.No. column
      if (columnKey === "sno") {
        const indexA = reportData.indexOf(a);
        const indexB = reportData.indexOf(b);
        return direction === "asc" ? indexA - indexB : indexB - indexA;
      }

      // Handle numeric values
      if (typeof a[columnKey] === 'number' && typeof b[columnKey] === 'number') {
        return direction === "asc" ? a[columnKey] - b[columnKey] : b[columnKey] - a[columnKey];
      }

      // Handle null/undefined values
      if (a[columnKey] === null || a[columnKey] === undefined) return 1;
      if (b[columnKey] === null || b[columnKey] === undefined) return -1;

      // Handle string values
      const valueA = String(a[columnKey]).toLowerCase();
      const valueB = String(b[columnKey]).toLowerCase();

      return direction === "asc"
        ? valueA.localeCompare(valueB)
        : valueB.localeCompare(valueA);
    });

    setFilteredData(sortedData);
    setSortConfig({ key: columnKey, direction });
  };
const handleSearch = (event) => {
  const query = event.target.value.toLowerCase();
  setSearchQuery(query);

  const filtered = reportData.filter((item) =>
    (item.itemName?.toLowerCase() || "").includes(query) ||
    (item.itemCode?.toLowerCase() || "").includes(query) ||
    (item.locCode?.toLowerCase() || "").includes(query) ||    // Branch Code search
    (item.branchName?.toLowerCase() || "").includes(query)    // Branch Name search
  );

  setFilteredData(filtered);
};

// Get current page data with Branch and BranchName search
useEffect(() => {
  if (reportData.length > 0) {
    const filtered = reportData.filter((item) =>
      (item.itemName?.toLowerCase() || "").includes(searchQuery.toLowerCase()) ||
      (item.itemCode?.toLowerCase() || "").includes(searchQuery.toLowerCase()) ||
      (item.locCode?.toLowerCase() || "").includes(searchQuery.toLowerCase()) ||    // Branch Code search
      (item.branchName?.toLowerCase() || "").includes(searchQuery.toLowerCase())    // Branch Name search
    );
    setFilteredData(filtered);
    setTotalPages(Math.ceil(filtered.length / rowsPerPage));
    setPage(1); // Reset to first page when filter changes
  }
}, [searchQuery, reportData, rowsPerPage]);

// Updated Export to CSV function to include Branch Code and Branch Name
const exportToCSV = () => {
  if (reportData.length === 0) {
    alert("No data to export");
    return;
  }
  
  const csvRows = [];
  
  let headers = [];
  
  // Both LAZIZ and other branch types will now include Branch Code and Branch Name
  if (branchType === 'LAZIZ') {
    headers = [
      "S.No.", "Branch Code", "Branch Name", "Rate Type", "Updated Date", "Item Code", "Item Name",
      "Item Family ID", "Retail Price"
    ];
  } else {
    headers = [
      "S.No.", "Branch Code", "Branch Name", "Rate Type", "Updated Date", "Item Code", "Item Name",
      "Item Family ID", "Retail Price", "Party Price", "Hotel Price", "Wholesale Price"
    ];
  }
  
  csvRows.push(headers.join(","));

  // Use reportData to export all data
  reportData.forEach((item, index) => {
    let row = [];
    
    // Common fields for all export types
    const baseRow = [
      index + 1,
      item.locCode || "-",
      `"${(item.branchName || "-").replace(/"/g, '""')}"`, // Escape quotes in branch names
      item.rateType || "-",
      formatDate(item.fromDate, "date"),
      item.itemCode || "-",
      `"${(item.itemName || "-").replace(/"/g, '""')}"`, // Escape quotes in item names
      item.itemFamilyID || "-"
    ];
    
    // For LAZIZ branch type, only include base fields and retail price
    if (branchType === 'LAZIZ') {
      row = [
        ...baseRow,
        item.retailPrice?.toFixed(2) || "0.00"
      ];
    } else {
      // Add all price columns
      row = [
        ...baseRow,
        item.retailPrice?.toFixed(2) || "0.00",
        item.partyPrice?.toFixed(2) || "0.00",
        item.hotelPrice?.toFixed(2) || "0.00",
        item.wholeSalePrice?.toFixed(2) || "0.00"
      ];
    }

    csvRows.push(row.join(","));
  });

  const csvContent = "data:text/csv;charset=utf-8," + csvRows.join("\n");
  const encodedUri = encodeURI(csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", `branch_rate_report_${branch ? branch : 'all'}_${fromDate.format('YYYYMMDD')}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

  return (
    <>
      <Header />
      <div className="customer-container">
        <div className="filter-container" style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px', flexWrap: 'wrap' }}>

          {/* Branch Type (Segment) Dropdown - First dropdown */}
          <FormControl variant="outlined" style={{ minWidth: 150 }}>
            <InputLabel id="branch-type-select-label">Segment</InputLabel>
            <Select
              labelId="branch-type-select-label"
              value={branchType}
              onChange={handleBranchTypeChange}
              label="Segment"
            >
              {segments.map((segment) => (
                <MenuItem key={segment.businessSegmentCode} value={segment.businessSegmentCode}>
                  {segment.businessSegmentName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Area Dropdown - Second dropdown */}
          <FormControl variant="outlined" style={{ minWidth: 130, maxWidth: 130 }}>
            <InputLabel id="area-select-label">Area</InputLabel>
            <Select
              labelId="area-select-label"
              value={area}
              onChange={handleAreaChange}
              label="Area"
              disabled={!branchType}
            >
              <MenuItem value="ALL">All</MenuItem>
              {areas.map((area) => (
                <MenuItem key={area.SFAreaId} value={area.SFAreaId}>
                  {area.SFAreaName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Branch Autocomplete - Third dropdown */}
          {branchType && (
            <Autocomplete
              style={{ minWidth: 180, maxWidth: 180 }}
              options={branchList || []}
              getOptionLabel={(option) => option.branchName || ""}
              value={selectedBranch}
              onChange={handleBranchChange}
              inputValue={branchInputValue}
              onInputChange={(event, newInputValue) => {
                setBranchInputValue(newInputValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Branch"
                  variant="outlined"
                  size="medium"
                />
              )}
              isOptionEqualToValue={(option, value) => option.branchID === value?.branchID}
            />
          )}

          {/* Date Pickers */}
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Bussiness Date"
              value={fromDate}
              onChange={handleFromDateChange}
              format="DD/MM/YYYY"
              slotProps={{
                textField: {
                  size: 'small',
                  sx: { width: 150, backgroundColor: '#F1F8E9' },
                },
              }}
            />
          </LocalizationProvider>

          {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="To Date"
              value={toDate}
              onChange={handleToDateChange}
              minDate={fromDate}
              maxDate={dayjs(fromDate).add(40, 'day')}
              format="DD/MM/YYYY"
              slotProps={{
                textField: {
                  size: 'small',
                  sx: { width: 150, backgroundColor: '#F1F8E9' },
                },
              }}
            />
          </LocalizationProvider> */}

          {/* Submit Button */}
          <Button
            onClick={fetchReportData}
            variant="contained"
            style={{ height: '40px' }}
            disabled={loading}
          >
            Submit
          </Button>

          {/* Export Button */}
          <Button
            variant="contained"
            onClick={exportToCSV}
            style={{ height: '40px' }}
            disabled={reportData.length === 0}
          >
            Export
          </Button>
        </div>

        {/* Search box */}
        {reportData.length > 0 && (
  <div style={{ padding: '10px' }}>
    <TextField
      label="Search by Item Name/Code, Branch Code/Name"
      variant="outlined"
      size="small"
      value={searchQuery}
      onChange={handleSearch}
      style={{ width: '200px' }}
      placeholder="Type to search..."
    />
  </div>
)}

        <div className="customer-table-container">
          <div className="customer-table-scroll">
            <table className="customer-table">
              <thead>
                <tr>
                  <th onClick={() => handleSort("sno")}> 
                    S.No. {renderSortIcon("sno")}
                  </th>
                  <th>Business Date</th>
                  <th onClick={() => handleSort("rateType")}> 
                    Rate Type {renderSortIcon("rateType")}
                  </th>
                  <th onClick={() => handleSort("fromDate")}>
                    Updated Date {renderSortIcon("fromDate")}
                  </th>
                  <th onClick={() => handleSort("locCode")}>
                    Branch Code {renderSortIcon("locCode")}
                  </th>
                  <th onClick={() => handleSort("branchName")}>
                    Branch Name {renderSortIcon("branchName")}
                  </th>
                  <th onClick={() => handleSort("itemCode")}>
                    Item Code {renderSortIcon("itemCode")}
                  </th>
                  <th onClick={() => handleSort("itemName")}>
                    Item Name {renderSortIcon("itemName")}
                  </th>
                  <th onClick={() => handleSort("itemFamilyID")}>
                    Item Family ID {renderSortIcon("itemFamilyID")}
                  </th>

                  {/* Show Retail Price for all branch types including LAZIZ */}
                  <th onClick={() => handleSort("retailPrice")}>
                    Retail Price {renderSortIcon("retailPrice")}
                  </th>

                  {/* Only show the remaining price columns if not LAZIZ branch type */}
                  {branchType !== 'LAZIZ' && (
                    <>
                      <th onClick={() => handleSort("partyPrice")}>
                        Party Price {renderSortIcon("partyPrice")}
                      </th>
                      <th onClick={() => handleSort("hotelPrice")}>
                        Hotel Price {renderSortIcon("hotelPrice")}
                      </th>
                      <th onClick={() => handleSort("wholeSalePrice")}>
                        Wholesale Price {renderSortIcon("wholeSalePrice")}
                      </th>
                    </>
                  )}
                </tr>
              </thead>

              {/* Table body section - updated for the new data structure */}
            {/* Table body section with updated date formatting */}
<tbody>
  {loading ? (
    <tr>
      <td colSpan={branchType === 'LAZIZ' ? 9 : 12} className="customer-loading-container">
        <CircularProgress />
      </td>
    </tr>
  ) : getCurrentPageData().length > 0 ? (
    getCurrentPageData().map((item, idx) => (
      <tr key={idx}>
        <td>{(page - 1) * rowsPerPage + idx + 1}</td>
        <td>{fromDate ? fromDate.format('DD/MM/YYYY') : '-'}</td>
        <td>{item.rateType || "-"}</td>
        <td>{formatDate(item.fromDate, "date")}</td>
        <td>{item.locCode || "-"}</td>
        <td>{item.branchName || "-"}</td>
        <td>{item.itemCode || "-"}</td>
        <td>{item.itemName || "-"}</td>
        <td>{item.itemFamilyID || "-"}</td>
        
        {/* Show Retail Price for all branch types including LAZIZ */}
        <td>{item.retailPrice?.toFixed(2) || "0.00"}</td>
        
        {/* Only show the remaining price columns if not LAZIZ branch type */}
        {branchType !== 'LAZIZ' && (
          <>
            <td>{item.partyPrice?.toFixed(2) || "0.00"}</td>
            <td>{item.hotelPrice?.toFixed(2) || "0.00"}</td>
            <td>{item.wholeSalePrice?.toFixed(2) || "0.00"}</td>
          </>
        )}
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan={branchType === 'LAZIZ' ? 9 : 12} className="customer-no-data-container">
        No data available.
      </td>
    </tr>
  )}
</tbody>
            </table>
          </div>

          {/* Add pagination controls */}
          {reportData.length > 0 && (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
              <Pagination
                count={totalPages}
                page={page}
                onChange={handlePageChange}
                color="primary"
                showFirstButton
                showLastButton
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default BranchDayRateReport;